"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _header = _interopRequireDefault(require("../header"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _LazyCharts = require("./LazyCharts");

var _interfaces = require("./interfaces");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _Loader = require("./Loader");

var _GraphTitle = require("./GraphTitle");

var _classnames = _interopRequireDefault(require("classnames"));

var _Message = require("../ui-components/Message");

var _Tabs = _interopRequireDefault(require("@insided/deprecated-preact-components/Tabs"));

var _ActiveCustomersTable = _interopRequireDefault(require("./ActiveCustomersTable"));

var _InactiveCustomersTable = _interopRequireDefault(require("./InactiveCustomersTable"));

var _constants = require("@insided/shared/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;
var DEFAULT_PAGINATION = {
  pagination: {
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE
  }
};

var EngagementGraphs = /*#__PURE__*/function (_Dashboard) {
  (0, _inherits2.default)(EngagementGraphs, _Dashboard);

  var _super = _createSuper(EngagementGraphs);

  function EngagementGraphs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EngagementGraphs);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, sortOrder, sortDirection, page, pageSize) {
        var _this$state, startDate, endDate, filterOptions;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state = _this.state, startDate = _this$state.startDate, endDate = _this$state.endDate;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                  page: page,
                  pageSize: pageSize,
                  sortOrder: sortOrder,
                  sortDirection: sortDirection
                };
                _context.next = 4;
                return _axios.default.post(url, {
                  filters: filterOptions
                });

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.setState({
      monthlyActiveCustomersData: [],
      isSalesforceIntegrationEnabled: true,
      isMonthlyActiveCustomersLoading: true,
      isLoading: true
    });

    return _this;
  }

  (0, _createClass2.default)(EngagementGraphs, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('engagement-dashboard');

                if (!window.sessionStorage.getItem('customersTablePagination')) {
                  window.sessionStorage.setItem('customersTablePagination', JSON.stringify(DEFAULT_PAGINATION));
                }

                _context2.next = 4;
                return Promise.all([(0, _get2.default)((0, _getPrototypeOf2.default)(EngagementGraphs.prototype), "componentDidMount", this).call(this), this.isSalesforceIntegrationEnabled()]);

              case 4:
                if (!this.state.isSalesforceIntegrationEnabled) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return Promise.all([this.fetchMonthlyActiveCustomers()]);

              case 7:
                _context2.next = 10;
                break;

              case 9:
                this.setState({
                  isMonthlyActiveCustomersLoading: false
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "isSalesforceIntegrationEnabled",
    value: function () {
      var _isSalesforceIntegrationEnabled = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _yield$axios$post, data;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _axios.default.post('/analyticsV2/isSalesforceIntegrationEnabled');

              case 2:
                _yield$axios$post = _context3.sent;
                data = _yield$axios$post.data;
                this.setState({
                  isSalesforceIntegrationEnabled: data.isSalesforceIntegrationEnabled
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function isSalesforceIntegrationEnabled() {
        return _isSalesforceIntegrationEnabled.apply(this, arguments);
      }

      return isSalesforceIntegrationEnabled;
    }()
  }, {
    key: "fetchMonthlyActiveCustomers",
    value: function () {
      var _fetchMonthlyActiveCustomers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this$state2, startDate, endDate, filterOptions, _yield$axios$post2, data;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  isMonthlyActiveCustomersLoading: true
                });
                _this$state2 = this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false)
                };
                _context4.prev = 3;
                _context4.next = 6;
                return _axios.default.post('/analyticsV2/fetchMonthlyActiveCustomers', {
                  filters: filterOptions
                });

              case 6:
                _yield$axios$post2 = _context4.sent;
                data = _yield$axios$post2.data;
                this.setState({
                  monthlyActiveCustomersData: data,
                  isMonthlyActiveCustomersLoading: false
                });
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);
                this.setState({
                  isMonthlyActiveCustomersLoading: false
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 11]]);
      }));

      function fetchMonthlyActiveCustomers() {
        return _fetchMonthlyActiveCustomers.apply(this, arguments);
      }

      return fetchMonthlyActiveCustomers;
    }()
  }, {
    key: "refetchData",
    value: function () {
      var _refetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.state.isSalesforceIntegrationEnabled) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return Promise.all([this.fetchMonthlyActiveCustomers()]);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refetchData() {
        return _refetchData.apply(this, arguments);
      }

      return refetchData;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          monthlyActiveCustomersData = _this$state3.monthlyActiveCustomersData,
          isSalesforceIntegrationEnabled = _this$state3.isSalesforceIntegrationEnabled,
          isMonthlyActiveCustomersLoading = _this$state3.isMonthlyActiveCustomersLoading,
          shouldChartRedraw = _this$state3.shouldChartRedraw,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate;
      var activeCustomersPercentageLabel = '% monthly active customers';
      var customerActivityDataSet = {
        datasets: [{
          label: 'Active customers',
          data: monthlyActiveCustomersData.map(function (d) {
            return {
              x: d.period,
              y: d.active
            };
          }),
          borderColor: _utils.BRAND_BLUE,
          backgroundColor: _utils.BRAND_BLUE
        }, {
          label: 'Inactive customers',
          data: monthlyActiveCustomersData.map(function (d) {
            return {
              x: d.period,
              y: d.total - d.active
            };
          }),
          borderColor: _utils.BRAND_YELLOW,
          backgroundColor: _utils.BRAND_YELLOW
        }]
      };
      var activeCustomersPercentageDataSet = {
        datasets: [{
          label: activeCustomersPercentageLabel,
          fill: false,
          data: monthlyActiveCustomersData.map(function (value) {
            var mac = value.active / value.total * 100;
            return {
              x: value.period,
              y: mac.toFixed()
            };
          }),
          borderColor: _utils.BRAND_BLUE,
          backgroundColor: _utils.BRAND_BLUE
        }]
      };
      return (0, _preact.h)("div", {
        className: "engagement-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "engagement-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "Engagement Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), !isSalesforceIntegrationEnabled ? (0, _preact.h)(_Message.Message, {
        variant: "warning",
        text: (0, _preact.h)("div", null, "To pull data into the engagement dashboard, please", ' ', (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/integrations/salesforce")
        }, "configure the Salesforce integration"), " and enable 'Import Salesforce Account data to ", _constants.PLATFORM_BRAND_NAME, "'.")
      }) : null, (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, this.getDateRangeFilter()), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this2.barChart = element;
        }
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('graph-row', {
          'no-data': !isSalesforceIntegrationEnabled
        })
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "% Monthly active customers",
        tooltipMessage: "The percentage of active customers out of the total number of customers in a given calendar month."
      }), !isSalesforceIntegrationEnabled && (0, _preact.h)("div", {
        className: "graph-row-no-data-text"
      }, "There's no data yet"), isSalesforceIntegrationEnabled && isMonthlyActiveCustomersLoading && (0, _preact.h)(_Loader.Loader, null), isSalesforceIntegrationEnabled && !isMonthlyActiveCustomersLoading && (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: activeCustomersPercentageDataSet,
        options: (0, _utils.getBarChartOptions)(false, 'month')
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('graph-row', {
          'no-data': !isSalesforceIntegrationEnabled
        })
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Customer activity per month",
        tooltipMessage: "The total number of companies where one or more users linked to the company had at least one page view in a given calendar month. / The total number of companies where the company status was marked as 'customer' in a given calendar month."
      }), !isSalesforceIntegrationEnabled && (0, _preact.h)("div", {
        className: "graph-row-no-data-text"
      }, "There's no data yet"), isSalesforceIntegrationEnabled && isMonthlyActiveCustomersLoading && (0, _preact.h)(_Loader.Loader, null), isSalesforceIntegrationEnabled && !isMonthlyActiveCustomersLoading && (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: customerActivityDataSet,
        options: (0, _utils.getBarChartOptions)(true, 'month')
      })))), (0, _preact.h)(_Tabs.default, {
        titles: ['Active customers', 'Inactive customers'],
        "data-track-type": "click"
      }, [(0, _preact.h)(_ActiveCustomersTable.default, {
        key: "activeCustomer",
        endDate: endDate,
        startDate: startDate,
        isSalesforceIntegrationEnabled: isSalesforceIntegrationEnabled,
        fetchData: this.fetchData
      }), (0, _preact.h)(_InactiveCustomersTable.default, {
        key: "inactiveCustomer",
        endDate: endDate,
        startDate: startDate,
        isSalesforceIntegrationEnabled: isSalesforceIntegrationEnabled,
        fetchData: this.fetchData
      })]), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return EngagementGraphs;
}(_interfaces.Dashboard);

var _default = EngagementGraphs;
exports.default = _default;